(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-cookie"]) return;
  try {
    
  (function(){
    var cookies = document.querySelector('.global-cookie');
    if (!cookies) return;

    var cookiesId  = 'vs-caboo-cookies-acceptance';
    var timeId     = 'vs-caboo-cookies-setup-time';
    var timeNow    = Date.now();
    var timeSetup  = localStorage.getItem(timeId);

    if (timeSetup === null){
      localStorage.setItem(timeId, timeNow);
    } else if (timeNow - timeSetup > 7*24*60*60*1000){
      localStorage.removeItem(cookiesId);
      localStorage.setItem(timeId, timeNow);
    }

    if (localStorage.getItem(cookiesId) !== 'closed') {
      cookies.classList.add('is-active');
    }

    function closeCookie() {
      cookies.classList.remove('is-active');
      localStorage.setItem(cookiesId, 'closed');
      setTimeout(function(){ cookies.parentNode && cookies.parentNode.removeChild(cookies); }, 600);
    }

    cookies.querySelectorAll('.cookie-close').forEach(function(btn){
      btn.addEventListener('click', closeCookie);
    });

    cookies.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { e.preventDefault(); closeCookie(); }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header"]) return;
  try {
    

const header = document.querySelector('.global-header');
const mobileMenuToggle = header.querySelector('.mobile-menu-toggle');

mobileMenuToggle.addEventListener('click', e => {
	if(root.classList.contains('mobile-menu-is-active')) {
		root.classList.remove('mobile-menu-is-active');
		root.classList.remove('noscroll');
	} else {
		if(root.classList.contains('minicart-is-active')) {
			root.classList.remove('minicart-is-active');
		}
		root.classList.add('mobile-menu-is-active');
		root.classList.add('noscroll');
	}
});
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-newsletter"] && !window.DesignMode) return;
  try {
    
	const newsletter = document.querySelector('.comp-email-capture');
	const newsletterId = 'vs-caboo-newsletter';
	const timeNow = new Date().getTime();
	const timeId = 'vs-caboo-newsletter-setup-time';
	const timeSetup = localStorage.getItem(timeId);

	if(timeSetup === null){
		localStorage.setItem(timeId, timeNow);
	} else if (timeNow - timeSetup > 7*24*60*60*1000){
		localStorage.removeItem(newsletterId);
		localStorage.setItem(timeId, timeNow);
	}

	function getDocHeight() {
    let D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    )
	}

	function amountscrolled() {
		let winheight= window.innerHeight || (document.documentElement || document.body).clientHeight;
		let docheight = getDocHeight();
		let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
		let trackLength = docheight - winheight;
		let pctScrolled = Math.floor(scrollTop/trackLength * 100) ;// gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
		if(hasLocalStorage && newsletter && localStorage.getItem(newsletterId) !== 'closed' && pctScrolled == 25) {
			newsletter.classList.add('is-active');
		}
	}
	amountscrolled();
	window.addEventListener('scroll', amountscrolled);

	newsletter.querySelector('.newsletter-close').onclick = function() {
		newsletter.classList.remove('is-active');
		localStorage.setItem(newsletterId, 'closed');

		setTimeout(function() {
			newsletter.parentNode.removeChild(newsletter);
		}, 600);
	}

  } catch(e) { console.error(e); }
})();
})();
